<template>
  <div class="login">
    <div class="tab">
      <div class="lefe"></div>
      <div class="title">登录</div>
      <div></div>
    </div>
    <div class="logo">
      <img src="static/img/dl_logo.png" alt />
      <p>怀南会供应商结算中心</p>
    </div>
    <div class="operation">
      <div class="input">
        <input type="text" v-model="name" placeholder="请输入账号" />
      </div>
      <div class="input">
        <input
          type="password"
          v-model="pwd"
          @keydown.enter="logging()"
          placeholder="请输入密码（6～16个字符或字母组成）"
        />
      </div>
      <button @click="logging()">登&nbsp;&nbsp;录</button>
      <span @click="$router.push('/login/forget_password')">忘记密码？</span>
    </div>
  </div>
</template>

<script>
//  校验短信验证码、校验手机号
import { captValid, mobileValid, setUser } from "common/js/util.js";
import { login } from "api/login";

export default {
  data() {
    return {
      name: "",
      pwd: "",
    };
  },
  mounted() {
    //   console.log(captValid);
  },
  methods: {
    logging() {
      let param = {
        loginName: this.name,
        loginPwd: this.pwd,
        userKind: "S",
      };
      login(param)
        .then((res) => {
          let { token } = res;
          localStorage.setItem("access_token", JSON.stringify(token));
          this.$router.push("/order");
          setUser(res);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  .tab {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 86px;
    .title {
      height: 73px;
      font-size: 52px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 73px;
    }
  }
  .logo {
    margin: 115px 0 152px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 128px;
      height: 128px;
      display: block;
      margin-bottom: 24px;
    }
    p {
      height: 50px;
      font-size: 36px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
    }
  }
  .operation {
    .input {
      margin: 0 70px 50px;
      border-bottom: 1px solid #e3e3e3;
      &:nth-child(2) {
        margin-bottom: 70px;
      }
      input {
        width: 100%;
        height: 45px;
        line-height: 45px;
        font-size: 32px;
        margin-bottom: 30px;
      }
    }
    button {
      font-size: 32px;
      display: block;
      width: 630px;
      height: 90px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      background: rgba(232, 64, 49, 1);
      border-radius: 45px;
      text-align: center;
      margin: 0 auto 40px;
    }
    > span {
      height: 40px;
      font-size: 28px;
      font-weight: 400;
      color: rgba(101, 101, 101, 1);
      line-height: 40px;
      text-align: right;
      margin: 0 70px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue